<template>
  <div id="app">
    <Header v-if="!hideLayout"/>
    <section :class="[hideLayout ? 'pt-0' : 'pt-18 lg:pt-24']" class="relative  pb-68 sm:pb-32 relative">
      <transition name="slide-show-hide">
        <Toast v-if="globalError || globalSuccess"/>
      </transition>

      <!-- side menu -->
      <drawer/>


      <router-view/>
    </section>
    <div
        class="hidden sm:absolute sm:bottom-0 sm:left-0 w-full sm:opacity-75 z-10"
    >
      <Footer v-if="!hideLayout"/>
    </div>
    <Footer v-if="!hideLayout"/>
  </div>
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  position: relative;
}
</style>
<script>
import Vue from 'vue'
import moment from 'moment'
import Header from './components/common/Header'
import Vuelidate from 'vuelidate'
import VueClassNames from 'vue-classnames'
import VueMask from 'v-mask'
import Footer from './components/common/Footer'
import { mapActions, mapGetters } from 'vuex'
import Toast from './components/common/Toast'
import VTooltip from 'v-tooltip'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCreditCardValidation from 'vue-credit-card-validation'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import Logo from './components/common/Logo.vue'
import Drawer from './components/common/Drawer.vue'
import UtilityMixin from '@/mixins/utilityMixin'
import VueFacebookPixel from 'vue-facebook-pixel'
import { StripePlugin } from '@vue-stripe/vue-stripe'

import VueSkeletonLoader from 'skeleton-loader-vue'

// Register the component globally
Vue.component('vue-skeleton-loader', VueSkeletonLoader)

Vue.use(VueFacebookPixel)
const options = {
  pk: process.env.VUE_APP_STRIPE_API_KEY,
}
Vue.use(StripePlugin, options)
Vue.use(vueCustomScrollbar)

Vue.use(VueMask)
Vue.use(VueClassNames)
Vue.use(Vuelidate)
Vue.use(VTooltip)
Vue.use(VueSweetalert2)
Vue.use(vueCustomScrollbar)
Vue.use(VueCreditCardValidation)
Vue.mixin(UtilityMixin)
Vue.mixin({
  computed: {
    isLoggedIn () {
      return this.$store.getters.isAuthenticated
    }
  },

  methods: {
    orderStatusTitle: status => {
      switch (status) {
        case 'ORDER_CREATED':
          return 'Order Created'
        case 'ATTENDEES_ADDED':
        case 'FINALIZED':
          return 'Ready to Send'
        case 'SENT_TO_ATTENDEES':
          return 'Sent to Attendees'
        case 'ORDERING_IN_PROGRESS':
          return 'Ordering In Progress'
        case 'ORDERS_PLACED':
          return 'Orders Placed'
        case 'FINISHED':
          return 'Order Finished'
        case 'BUILDING_BOXES':
          return 'Building Boxes'
        case 'BOXES_BUILT':
          return 'Boxes Built'
        case 'OUT_FOR_DELIVERY':
          return 'Out For Delivery'
        case 'CANCELLED':
          return 'CANCELLED'
        case 'FULL_FILLED':
          return 'Order Fulfilled'
        default:
          return ''
      }
    },
    roleTitle       : role => {
      switch (role) {
        case 'team_member':
          return 'Team Member'
        case 'caterer':
          return 'Caterer'
        case 'supplier':
          return 'Supplier'
        case 'event_planner':
          return 'Event Planner'
        default:
          return ''
      }
    },
    showGlobalSuccessMessage (message) {
      this.$store.dispatch('setSuccessMessage', message)
    },
    showGlobalErrorMessage (message) {
      this.$store.commit('SET_ERROR_MESSAGE', message)
      setTimeout(() => {
        this.$store.commit('SET_ERROR_MESSAGE', null)
      }, 3000)
    }
  }
})

Vue.filter('currencyFormat', function (value) {
  return value === 'free' ? 'Free forever, baby!' : '$' + value
})

Vue.filter('date', function (date) {
  return date ? moment(date).format('MMM DD, YYYY') : ''
})

Vue.filter('datetime', function (date) {
  return date ? moment(date).format('MMM DD, YYYY,  HH:mm') : ''
})

export default {

  head: {
    meta: [
      { name: 'facebook-domain-verification', content: 'pka8dome8lh205ukgv0bd5xab1os4e' }
    ]
  },

  data () {
    return {
      hideLayout: false,
    }
  },

  methods : {
    ...mapActions(['getPersonalDetails', 'setAuthToken', 'isAuthenticated']),

    switchLayoutState (state) {
      this.hideLayout = state
    }

  },
  computed: {
    ...mapGetters(['globalError', 'globalSuccess'])
  },
  async created () {
    this.$root.$on('hideLayout', state => this.hideLayout = state.hide)

    const token = localStorage.getItem('access_token')
    if (token) {
      this.setAuthToken(token)
      await this.getPersonalDetails()
    }
  },

  beforeDestroy () {
    this.$root.$off('hideLayout', state => this.hideLayout = state.hide)
  },

  components: {
    Toast,
    Footer,
    Header,
    Logo,
    Drawer
  }
}
</script>
